import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SubscriptionService } from 'src/app/billing/services/subscription.service';
import { AI_CREDITS_QUANTITY_STEP } from 'src/app/components/plans/plans.service';
import { UpdateSubscriptionService } from '../../services/update-subscription.service';

type PurchaseAction =
  | 'add'
  | 'remove'
  | 'unlimited'
  | 'add-interactive'
  | 'remove-interactive'
  | 'add-additional-ai-credits'
  | 'remove-additional-ai-credits'
  | 'annual'
  | 'change';

@Component({
  selector: 'update-subscription-success',
  templateUrl: './update-subscription-success.component.html',
  styleUrls: ['./update-subscription-success.component.scss'],
  standalone: false,
})
export class UpdateSubscriptionSuccessComponent {
  @Input() purchaseAction: PurchaseAction;
  @Input() planName: string;
  @Output() closeEvent = new EventEmitter<any>();

  get licensesToAdd(): number {
    return this.purchaseAction === 'add-interactive'
      ? this.updateSubscriptionService.interactiveLicensePurchase.licensesToAdd
      : this.updateSubscriptionService.displayLicensePurchase.licensesToAdd;
  }

  get licensesToRemove(): number {
    return this.purchaseAction === 'remove-interactive'
      ? this.updateSubscriptionService.interactiveLicensePurchase
          .licensesToRemove
      : this.updateSubscriptionService.displayLicensePurchase.licensesToRemove;
  }

  get licenseQuantityMultiplier(): number {
    return this.isAiCreditsPurchaseAction ? AI_CREDITS_QUANTITY_STEP : 1;
  }

  get licenseUnitLabel(): string {
    if (this.isAiCreditsPurchaseAction) {
      return 'AI credits';
    }

    return this.purchaseAction === 'add-interactive' ||
      this.purchaseAction === 'remove-interactive'
      ? 'interactive licenses'
      : 'display licenses';
  }

  get isAiCreditsPurchaseAction(): boolean {
    return (
      this.purchaseAction === 'add-additional-ai-credits' ||
      this.purchaseAction === 'remove-additional-ai-credits'
    );
  }

  constructor(
    public updateSubscriptionService: UpdateSubscriptionService,
    public subscriptionService: SubscriptionService,
  ) {}
}
